/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext } from 'react';
import '../PendingForReviewToll/violationforplazareviewlisting.css'
import Table from 'react-bootstrap/Table'
import { downloadAssignedViolation, getGridDataForPendingForReviewCompleteListing, getAuditGridData } from '../../../common/apiService'
import CommonDateRangePicker from '../../../common/daterangepicker'
import CustomPagination from '../../../common/custom_pagination'
import Loader from 'react-loader-spinner';
import Moment from 'moment'
import SelectSearch, { fuzzySearch } from "react-select-search";
import { BsArrowDown, BsArrowUp, BsFileEarmarkText } from 'react-icons/bs'
import Selfassignpopupscreenui from '../dashboard/selfassignpopupscreenui'
import CaseReviewScreenPopup from '../CaseReviewScreenPopup/casereviewscreenpopup'
import '../../../common/selectsearch.css';

import AuditLogDetailPopup from '../../Contents/auditlogdetailpopup'
import { getJsonData } from '../../../service/utilService'
import ReactTooltip from 'react-tooltip';
import DownloadBtn from '../../../common/DownloadBtn';
import * as FileSaver from "file-saver";
import { toast } from 'react-toastify';
import { UserContext } from '../../../contexts/UserContext';


export default function CompletedViolationListing() {

    const userDetail = useContext(UserContext);
    const [downloaddata, setDownloaddata] = useState([]);
    const [gridList, setGridList] = useState([]);
    const [jsonData, setJsonData] = useState(getJsonData(userDetail));
    const [mappedAVC] = useState("");
    const [totalPage, setTotalPage] = useState(0);
    const [currentPage, setCurrentPage] = useState("0");
    const [violationtype] = useState("Complete Violations");
    const [Show1, setShow1] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showModel, setShowModel] = useState(false);
    const [currentViolationIndex, setCurrentViolationIndex] = useState("0");
    const [adjtype, setAdjType] = useState('""');
    const [viostatus, setVioStatus] = useState('""');
    const [isSpUser, setIsSpUser] = useState(false);
    const [tollplaza, setTollPlaza] = useState();
    const [tolldata, setTollData] = useState([]);
    const [totalGridData, setTotalGridData] = useState(0);
    const [showAuditLogPopup, setShowAuditLogPopup] = useState(false);
    const [auditpopupgridList, setAuditPopupGridList] = useState([]);
    const [selectedrrnno, setSelectedRrnNo] = useState(0);
    const [finalGridList, setGridListFinal] = useState([]);
    const [loadingreport, setLoadingReport] = useState(false);

    
    let adjustmenttypeData = [
        { name: 'All', value: '""' },   
        { name: 'DA', value: 'DA' },
        { name: 'CA', value: 'CA' },
        { name: 'NIL', value: 'Nil' },
        { name: "Manual DA", value: "Manual DA" }
    ];

    let violationstatusData = [
        { name: 'All', value: '""' },
        {name: 'Approve', value:'Accept'},
        { name: 'Reject', value: 'Reject'},
    ];
    const [sortedby, setSortedBy] = useState('');
    const [orderby, setOrderBy] = useState('asc');
    // const [pendingviocount, setPendingVioCount] = useState(0);

    useEffect(() => {
    if(userDetail?.plaza!==null && userDetail?.plaza!==""){
        var plaza = userDetail.plaza;
    //const plazaArr =  plaza.split(",");
    const plazadata = [];
    for (let p of userDetail?.plaza) {
        const json = { name: p, value: p};
        plazadata.push(json);
    }
    setTollData(plazadata)
    }
        // eslint-disable-next-line
    }, [userDetail])

    useEffect(() => {
    if(userDetail?.plaza!==null && userDetail?.plaza!==""){
        setTimeout(() => setTollPlaza(userDetail?.plaza),0)
        }
    }, [userDetail])

    useEffect(() => {
        if (tollplaza)
        griddata();
        clearConsole();
        // eslint-disable-next-line
    }, [jsonData, mappedAVC, viostatus, adjtype, tollplaza])

    useEffect(() => {
        if (currentPage !== "0")
            pageChange();
        // eslint-disable-next-line
    }, [currentPage])

    useEffect(() => {
        if (sortedby !== "")
            pageChange();
        // eslint-disable-next-line
    }, [sortedby, orderby]);

    useEffect(() => {
        const spUser = userDetail.userType === 'SP'
        setIsSpUser(spUser);
    }, [userDetail]);

    const downloadfile = async () => {
        const startDate = new Date(jsonData.startDate);
        const endDate = new Date(jsonData.endDate);

        const diffTime = Math.abs(endDate - startDate);
        const diffDays = diffTime / (1000 * 60 * 60 * 24);

        if (diffDays > 31) {
            toast.warning("Please select date range within 31 days");
            return;
        }

        const bodyJson = {
            mapped_avc: mappedAVC,
            plazaIds: Array.isArray(jsonData.plazaIds) ? jsonData.plazaIds.join(",") : jsonData.plazaIds
        }
        const { plazaIds, ...restJsonData } = jsonData; // Remove plazaIds from jsonData before adding it to headerJson
        const headerJson = {
            adjtype: adjtype,
            status: viostatus,
            spuser: isSpUser,
            ...restJsonData
        }
        setLoadingReport(true);

        try {
            const res = await downloadAssignedViolation(headerJson, bodyJson);
    
            const filename = res.headers["x-filename"];
        
            if (filename === undefined || !filename || res.data.size === 0) {
                toast.warning("No data found or filename missing");
                setLoadingReport(false);
                return;
            }
        
            let fileType = "application/octet-stream";
            if (filename.endsWith(".xlsx")) {
                fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            } else if (filename.endsWith(".zip")) {
                fileType = "application/zip";
            }
        
            const blob = new Blob([res.data], { type: fileType });
            FileSaver.saveAs(blob, filename);
        } catch (err) {
            console.error("Download failed", err);
            toast.error("Download failed");
        }

        setLoadingReport(false);
    }


    const getJson = () => {
        const bodyJson = {
            mapped_avc: mappedAVC,
            plazaIds: Array.isArray(jsonData.plazaIds) ? jsonData.plazaIds.join(",") : jsonData.plazaIds
        }
        const { plazaIds, ...restJsonData } = jsonData; // Remove plazaIds from jsonData before adding it to headerJson
        const headerJson = {
            adjtype: adjtype,
            status: viostatus,
            spuser: isSpUser,
            ...restJsonData,
        }
        
        const paramJson = {
            offset: currentPage,
            limit: '50',
            sort_c: sortedby,   
            sort_t: orderby
        }
        const json = {
            bodyJson: bodyJson,
            headerJson: headerJson,
            paramJson: paramJson
        }
        return json;
    }

    const griddata = async () => {
        setLoading(true);
        const { headerJson, bodyJson, paramJson } = getJson();
        try{
            console.time("api");
            const res = await getGridDataForPendingForReviewCompleteListing(headerJson, bodyJson, paramJson);
            console.timeEnd("api");
            const data = res.data.data;
            if (data.length === 0) {
                setGridList([]);
                console.log("No records found for selected filters.");
              }
            setGridList(data);
            const totalpages = res.data.pages;
            setTotalPage(totalpages);
            setTotalGridData(res.data.totalElements);
            setLoading(false);
        }catch{
            setTotalPage(0);
            setTotalGridData(0);
            setGridList([]);
            setLoading(false);
        }
    }

    const pageChange = () => {
        griddata();
    }

    const clearConsole = () => {
        setTimeout(() => {
            // console.clear();
        }, 800)
    }

    const gridShort = (val) => {
        if (val !== sortedby) {
            setSortedBy(val);
            setOrderBy('asc');
        } else {
            if (orderby === 'asc')
                setOrderBy('desc');
            else
                setOrderBy('asc')
        }
    }

    const arrow = (val) => {
        if (val === sortedby && orderby === 'asc')
            return (<BsArrowDown className="sort-arrow" />);
        else if (val === sortedby && orderby === 'desc')
            return (<BsArrowUp className="sort-arrow" />)
    }

    const getAuditPopupGridData = (row) => {
        const caseId = row.id;
        setSelectedRrnNo(row.rrn);
        setLoading(true);
        getAuditGridData(caseId).then(res => {
            setGridListFinal([]);
            res.data.forEach(function (item, index) {
                if(item.updatedColumns?.length > 0) { item.updatedColumns.forEach(function (items, indexs) {
                    if (items === 'Remark' || items === 'AssignedUserID' || items === 'Maker_Attempt' || items === 'Checker_Attempt' || items === 'Case_Status_Description' || items === 'case_life' || items === 'plaza_date_mark' || items === 'bank_date_mark' || items === 'expired_dt') {
                        finalGridList.push({ "datetime": item.modifiedDate, "from": item.oldData[items], "to": item.newData[items], "colmname": items })
                    }
            }); }
            });

            setLoading(false);
        
            if (res.data && res.data !== "No record Found!")
                setAuditPopupGridList(finalGridList);
            else
                setAuditPopupGridList([]);
            setShowAuditLogPopup(true);
        }).catch(err => {
            setLoading(false);
        })
    }

    return (
        <>
            <ReactTooltip />
           <Selfassignpopupscreenui
                activeCount={0}
                show1={Show1}
                setShow1={setShow1}
            />
           <CaseReviewScreenPopup
                showModel={showModel}
                setShowModel={setShowModel}
                parentGridData={gridList}
                setParentGridData={setGridList}
                violationtype={violationtype}
                index={currentViolationIndex}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                totalPage={totalPage}
            />
            <Loader className="loader"
                type="ThreeDots"
                color="#9c1d26"
                height={100}
                width={100}
                visible={loading}
                style={{backgroundColor:'lightgrey'}} />

               <AuditLogDetailPopup
                setShowAuditLogPopup={setShowAuditLogPopup}
                showAuditLogPopup={showAuditLogPopup}
                gridList={auditpopupgridList}
                selectedrrnno={selectedrrnno}
            />

            <div className="container-fluid assignMakers">
                <div className="row">
                    <div className="col-md-5">
                        <h3>{violationtype}  {userDetail.roles?.includes('checker') ? <span>for recheck</span> : null}  </h3>
                    </div>
                    <div className="col-md-4">
                    </div>
                    {/* <div className="col-md-3">
                        <button className="assignedbtn" onClick={() => setShow1(true)}>Assign to me</button>
                    </div> */}
                </div>
            </div>
            <div className="container-fluid">
                <div className="col-md-12">
                    <div className="row filterssrtip">
                        <div className="col-md-3">
                            <h4 className="lowh3">Completed violations - <span>{totalGridData}</span>
                            </h4>
                        </div>
                        <div className="col-md-9 option">
                            <DownloadBtn
                                downloaddata={downloaddata}
                                loadingreport={loadingreport}
                                downloadexcel={downloadfile}
                            />
                            <CommonDateRangePicker
                                plazaClassName="tollfilter"
                                datepickerClassName="daterange"
                                setjsonData={setJsonData}
                            />
                            <div className="violationstatusfilter">
                                <SelectSearch
                                    options={violationstatusData}
                                    search
                                    filterOptions={fuzzySearch}
                                    placeholder="Violation Status"
                                    value={viostatus}
                                    // multiple="true"
                                    onChange={(selectedValue) => setVioStatus(selectedValue)}
                                />
                            </div>
                            <div className="adjustmenttypefilter">
                                <SelectSearch
                                    options={adjustmenttypeData}
                                    search
                                    filterOptions={fuzzySearch}
                                    placeholder="Adjustment Type"
                                    value={adjtype}
                                    // multiple="true"
                                    onChange={(selectedValue) => setAdjType(selectedValue)}
                                />
                            </div>
                            {/* <div className="plazaidfilter" >
                                <SelectSearch style={{ width: 100 }}
                                    options={tolldata}
                                    search
                                    filterOptions={fuzzySearch}
                                    placeholder="Select Plaza"
                                    multiple="true"
                                    value={tollplaza}
                                    onChange={(selectedValue) => setTollPlaza(selectedValue)}
                                />
                            </div> */}
                        </div>
                    </div>
                    <div style={{ maxHeight: 600, overflowX: 'hidden', width: '100%', marginBottom: 10 }}>
                    <Table striped bordered hover variant="light" className="customTable">
                        <thead>
                                <tr className="pointer" style={{ position: 'sticky', top: -1 }}>
                                <th>RRN </th>
                                <th>Tag ID </th>
                                <th>Reg Number </th>
                                <th>Processing Time </th>
                                <th>Mapped AVC </th>
                                <th>NPCI VC </th>
                                <th>Status Remarks </th>
                                <th>Journey Type </th>
                                {/* <th onClick={() => gridShort('eta')}>ETA {arrow('eta')}</th> */}
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {gridList.length>0?
                                gridList.map((e, index) => {
                                    return (
                                        <tr>
                                            <td>{e.rrn}</td>
                                            <td>{e.tagId}</td>
                                            <td>{e.regNumber}</td>
                                            <td style={{width:190}}>{Moment.utc(e.processingTime).format("YYYY-MM-DD, HH:mm")}</td>
                                            <td>{e.mappedAvc}</td>
                                            <td>{e.npciVehicleClass}</td>
                                            <td>{e.remark}</td>
                                            <td>{e.journeyType}</td>
                                            {/* <td><span className="etablock pink-eta">24 hours</span></td> */}
                                            <td style={{ width: 60, cursor: 'auto',padding:'7px 15px' }} >
                                                    <div className="ripple" 
                                                        onClick={()=>getAuditPopupGridData(e)}>
                                                        <BsFileEarmarkText  title="Log details"className="auditbtn edit"  />
                                                    </div> 
                                                </td>
                                        </tr>
                                    )
                                })
                            :
                            <tr>
                                <td colSpan="8" style={{ textAlign: 'center' }}>Data Not Found!</td>
                            </tr>
                            }


                        </tbody>
                    </Table>
                    </div>
                    <CustomPagination
                        currentPage={currentPage}
                        totalPage={totalPage}
                        setCurrentPage={setCurrentPage}
                    />
                </div>
            </div>
        </>
    )
}